export enum FiClientType {
    Web = 0,
    CordovaMobileApp = 1,
    FlutterMobileApp = 2,
}
